import * as React from "react";
import SideNavigation from "@amzn/awsui-components-react/polaris/side-navigation";
import Header from "@amzn/awsui-components-react/polaris/header";
import Box from "@amzn/awsui-components-react/polaris/box";
import PageShell from "../../../../global/components/PageShell";
import GetAllClaimsSection from "./GetAllClaimsSection";
import ApplyClaimDispositionSection from "./ApplyClaimDispositionSection";

type PageView = "get-all-claims" | "apply-disposition";

interface State {
  activePage: PageView;
  navOpen: boolean;
}

class ClaimsPage extends React.Component<{}, State> {
  constructor(props: {}) {
    super(props);
    this.state = { activePage: "get-all-claims", navOpen: true };
  }

  private renderContent() {
    switch (this.state.activePage) {
      case "get-all-claims":
        return <GetAllClaimsSection />;
      case "apply-disposition":
        return <ApplyClaimDispositionSection />;
      default:
        return (
          <Box textAlign="center" color="text-body-secondary" padding="xxl">
            Select an operation from the sidebar
          </Box>
        );
    }
  }

  render() {
    return (
      <PageShell
        navigationOpen={this.state.navOpen}
        onNavigationChange={(open) => this.setState({ navOpen: open })}
        navigation={
          <SideNavigation
            header={{ text: "Claims Operations", href: "#get-all-claims" }}
            activeHref={`#${this.state.activePage}`}
            onFollow={(e) => {
              e.preventDefault();
              this.setState({ activePage: e.detail.href.replace("#", "") as PageView });
            }}
            items={[
              {
                type: "section",
                text: "Claims",
                items: [
                  { type: "link", text: "Get All Claims", href: "#get-all-claims" },
                  { type: "link", text: "Apply Disposition", href: "#apply-disposition" },
                ],
              },
            ]}
          />
        }
        content={
          <div>
            <Box padding={{ top: "l", bottom: "l" }}>
              <Header
                variant="h1"
                description="View and manage pharmacy claims for test customers"
              >
                Claims Operations
              </Header>
            </Box>
            {this.renderContent()}
          </div>
        }
      />
    );
  }
}

export default ClaimsPage;
